/* Wolden theme - marquee, mobile menu, AJAX cart drawer, product gallery */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var v = (cents || 0) / 100;
    return "£" + v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* announcement marquee */
  var marq = $("#marq");
  if (marq) {
    var ann = ["FREE UK SHIPPING", "30-DAY RETURNS", "SECURE CHECKOUT"];
    var out = "";
    for (var i = 0; i < 6; i++) out += "<span>" + ann[i % 3] + "</span>";
    marq.innerHTML = out;
  }

  /* mobile burger */
  var burger = $(".burger"), links = $(".hlinks");
  if (burger && links) {
    burger.addEventListener("click", function (e) { e.stopPropagation(); links.classList.toggle("open"); });
    document.addEventListener("click", function (e) { if (links.classList.contains("open") && !links.contains(e.target) && !burger.contains(e.target)) links.classList.remove("open"); });
    links.addEventListener("click", function (e) { if (e.target.closest("a")) links.classList.remove("open"); });
  }

  /* toast */
  var toastEl = $("#toast"), toastT;
  function toast(msg) { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add("on"); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 2200); }

  /* cart drawer */
  var drawer = $("#drawer"), scrim = $("#scrim"), ditems = $("#ditems");
  function openDrawer() { if (drawer) drawer.classList.add("on"); if (scrim) scrim.classList.add("on"); renderCart(); }
  function closeDrawer() { if (drawer) drawer.classList.remove("on"); if (scrim) scrim.classList.remove("on"); }
  var cartBtn = $("#cartBtn"), dclose = $("#dclose");
  if (cartBtn) cartBtn.addEventListener("click", openDrawer);
  if (dclose) dclose.addEventListener("click", closeDrawer);
  if (scrim) scrim.addEventListener("click", closeDrawer);

  function setCount(n) { var cc = $("#cc"); if (cc) cc.textContent = n; }

  function renderCart() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      var sub = $("#subtotal"), tot = $("#carttotal");
      if (sub) sub.innerHTML = money(cart.items_subtotal_price);
      if (tot) tot.innerHTML = money(cart.total_price);
      if (!ditems) return;
      if (!cart.items.length) { ditems.innerHTML = '<div class="empty">Your cart is empty.<br>Time to find your ride.</div>'; return; }
      ditems.innerHTML = cart.items.map(function (it) {
        return '<div class="ditem">' +
          '<img src="' + (it.image ? it.image : "") + '" alt="">' +
          '<div class="di"><h4><a href="' + it.url + '">' + it.product_title + '</a></h4>' +
          '<div class="g">' + money(it.final_price) + '</div>' +
          '<div class="qrow"><div class="qstep">' +
          '<button data-key="' + it.key + '" data-q="' + (it.quantity - 1) + '">−</button>' +
          '<span class="qn">' + it.quantity + '</span>' +
          '<button data-key="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div>' +
          '<button class="rm" data-key="' + it.key + '" data-q="0">Remove</button></div></div></div>';
      }).join("");
      $$("#ditems [data-key]").forEach(function (b) {
        b.addEventListener("click", function () { changeLine(b.getAttribute("data-key"), parseInt(b.getAttribute("data-q"), 10)); });
      });
    });
  }

  function changeLine(key, qty) {
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function () { renderCart(); });
  }

  function addToCart(id, qty, go) {
    if (!id) return;
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); }).then(function () {
        if (go) { window.location.href = "/checkout"; return; }
        toast("Added to cart");
        openDrawer();
      }).catch(function () { toast("Could not add to cart"); });
  }

  /* card add buttons */
  $$("[data-add]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); addToCart(b.getAttribute("data-variant"), 1, false); });
  });

  /* product page */
  var big = $("#pdpBig");
  $$(".pv-thumbs img").forEach(function (t) {
    t.addEventListener("click", function () {
      if (big) big.src = t.getAttribute("data-u");
      $$(".pv-thumbs img").forEach(function (x) { x.classList.remove("on"); });
      t.classList.add("on");
    });
  });
  var qv = $("#qv"), q = 1;
  var qm = $("#qm"), qp = $("#qp");
  if (qm) qm.addEventListener("click", function () { q = Math.max(1, q - 1); if (qv) qv.textContent = q; });
  if (qp) qp.addEventListener("click", function () { q = q + 1; if (qv) qv.textContent = q; });
  var vsel = $("#variantSelect");
  function currentVariant(btn) { return vsel ? vsel.value : btn.getAttribute("data-variant"); }
  var pdpAdd = $("#pdpAdd"), pdpBuy = $("#pdpBuy");
  if (pdpAdd) pdpAdd.addEventListener("click", function () { addToCart(currentVariant(pdpAdd), q, false); });
  if (pdpBuy) pdpBuy.addEventListener("click", function () { addToCart(currentVariant(pdpBuy), q, true); });

  /* initial count sync */
  renderCartCountOnly();
  function renderCartCountOnly() { fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }
})();
